import { useNavigate, useLocation } from 'react-router-dom';
import { refreshToken, accessToken } from '../utils/auth';
import { useReturnTo } from './useReturnTo';

export const useSetTokensWithRedirect = (onSuccess?: (tokens?: any) => void) => {
    const navigate = useNavigate();
    const location = useLocation();
    const returnTo = useReturnTo();

    const setTokensWithRedirect = async (tokens: any) => {
        try {
            refreshToken.set(tokens.refresh);
            accessToken.set(tokens.access);

            if (onSuccess) {
                onSuccess(tokens);
                return;
            }

            if (returnTo) {
                navigate(returnTo);
                return;
            }

            const fromPath = (location.state as any)?.from?.pathname as string | undefined;
            if (fromPath) {
                navigate(fromPath);
            }
        } catch (error) {
            console.log('error', error);
        }
    };
    return setTokensWithRedirect;
};
